import request from '@/utils/request'

// v80d1010List
export function v80d1010List(param) {
    let data = param
    return request({
      url: `/v80/v80d1010/v80d1010List`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
  }

  // v80d1010DetailList
  export function v80d1010DetailList(param) {
    let data = param
    return request({
      url: `/v80/v80d1010/v80d1010DetailList`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
  }

  // v80d1010DetailFileList
  export function v80d1010DetailFileList(param) {
    let data = param
    return request({
      url: `/v80/v80d1010/v80d1010DetailFileList`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
  }